import fetchIntercept from 'fetch-intercept';

export const HeaderInterceptor = () => {
  fetchIntercept.register({
    request: function (url, config) {
      // Modify the url or config here
      if(addHeader(url))
      config.headers.appname = 'Hospital Web Chat';
      return [url, config];
    },

    requestError: function (error) {
      // Called when an error occured during another 'request' interceptor call
      return Promise.reject(error);
    },

    response: function (response) {
      // Modify the reponse object
      return response;
    },

    responseError: function (error) {
      // Handle an fetch error
      return Promise.reject(error);
    },
  });
};

const addHeader=(url)=>{
  if(url.includes("getFinalBillDataByOCR"))
  return false
  
  return true
}
